import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";

export default function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f5f3ed] px-6" data-testid="admin-forgot-page">
      <div className="w-full max-w-md bg-white border border-[#c19872] rounded-xl p-10">
        <p className="btw-overline mb-3">Behind the Love</p>
        <h1 className="text-3xl font-bold mb-1">Forgot password</h1>
        {sent ? (
          <p className="text-sm text-black mt-4" data-testid="forgot-sent">
            If that email belongs to an admin, a reset link is on its way. It works
            once and expires in 1 hour.
          </p>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <p className="text-sm text-black mb-8 mt-4">
              Enter your admin email and we'll send you a reset link.
            </p>
            <label className="btw-overline block mb-2">Email</label>
            <input
              data-testid="forgot-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="btw-input mb-8"
            />
            <button type="submit" disabled={busy} data-testid="forgot-submit" className="btw-btn w-full">
              {busy ? "Sending…" : "Email reset link"}
            </button>
          </form>
        )}
        <p className="text-sm text-black mt-8">
          <Link to="/admin/login" className="underline" data-testid="back-to-login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
